import useSWR from "swr";
import { fetcher, asList } from "@/lib/api";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { CategoryBento } from "@/components/CategoryBento";
import { FeaturedProjects } from "@/components/FeaturedProjects";
import { PrintCTA } from "@/components/PrintCTA";
import { ShowroomVisit } from "@/components/ShowroomVisit";
import { StudioCTA } from "@/components/StudioCTA";
import { Reveal, Eyebrow } from "@/components/Reveal";

const SectionHead = ({ eyebrow, title, aside }) => (
  <Reveal className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
    <div>
      <Eyebrow>{eyebrow}</Eyebrow>
      <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl text-[#F5F3EF] leading-[1] max-w-2xl">{title}</h2>
    </div>
    {aside && <p className="text-[#A09E97] max-w-sm">{aside}</p>}
  </Reveal>
);

export default function Home() {
  const { data: catData } = useSWR("/categories", fetcher);
  const { data: featData } = useSWR("/items?featured=true", fetcher);
  const cats = asList(catData);
  const featured = asList(featData);
  const itemCount = cats.reduce((s, c) => s + (c.count || 0), 0);

  return (
    <main>
      <Hero itemCount={itemCount} catCount={cats.length} />
      <Marquee />
      <section className="mx-auto max-w-[1440px] px-5 sm:px-10 pt-24">
        <StudioCTA />
      </section>
      <section id="catalogue" className="mx-auto max-w-[1440px] px-5 sm:px-10 pt-32">
        <SectionHead eyebrow="Index · Collections" title={<>The catalogue, <em className="text-[#E5C158]">in full.</em></>}
          aside="Projects we've delivered alongside the hardware, stone, boards and appliances we source from our suppliers." />
        <CategoryBento cats={cats} />
      </section>
      {featured.length > 0 && (
        <section className="mx-auto max-w-[1440px] px-5 sm:px-10 pt-40">
          <SectionHead eyebrow="Selected work" title={<>Rooms we've <em className="text-[#E5C158]">built.</em></>} />
          <FeaturedProjects items={featured} />
        </section>
      )}
      <section className="mx-auto max-w-[1440px] px-5 sm:px-10 pt-40">
        <PrintCTA cats={cats} />
      </section>
      <section id="showroom" className="mx-auto max-w-[1440px] px-5 sm:px-10 pt-40">
        <ShowroomVisit />
      </section>
    </main>
  );
}
